export default function NewGroupPlusIcon() {
  return (
    <>
      <svg
        width="44"
        height="44"
        viewBox="0 0 36 36"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="36" height="36" rx="18" fill="#F0F3F9" />
        <path
          d="M18 13.5V22.5M22.5 18L13.5 18"
          stroke="#3D4A5C"
          stroke-width="1.25"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </>
  );
}
